/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from 'react'
import { IonModal } from '@ionic/react'
const downloadCloud = '/images/Cloud_download.svg'
const playIcon = '/images/play_icon.svg'

const NewsMediaGallery = ({ gallery }) => {
  const [showProductModal, setProductModal] = useState(-1)
  const getImgUrl = (obj) => {
    const dynamicImage = obj.dynamicMediaUrl || obj.url
    const imgUrl = dynamicImage || `https://img.youtube.com/vi/${obj.url.split('/')?.pop()}/0.jpg`
    return imgUrl
  }
  const renderGallery = () => {
    return gallery.map((obj, i) => {
      const imgUrl = getImgUrl(obj)
      return (
        <div className="news-gallery__grid-item" key={obj.url}>
          <div
          tabIndex={0}
            data-testid="news-gallery-grid-item-image"
            className="news-gallery__grid-item-image"
            onClick={(e) => {
              setProductModal(i)
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                setProductModal(i)
              }
            }}
>
            {obj.type === 'video' && (
              <img className="news-gallery__grid-item-image-play" src={playIcon} alt={obj.type} />
            )}
            <img
              className={
                obj.type === 'video'
                  ? 'news-gallery__grid-item-image-main news-gallery__grid-item-image-main-video'
                  : 'news-gallery__grid-item-image-main'
              }
              src={imgUrl}
              alt={obj.type}
            />
          </div>
          <div className="news-gallery__grid-item-description">
            <div className="news-gallery__grid-item-title">{obj.title}</div>
            {obj.type === 'image' && (
              <div className="news-gallery__grid-item-download">
                <a href={obj.dynamicMediaUrl || obj.url}>
                  <img src={downloadCloud} alt={obj.type} />
                </a>
              </div>
            )}
          </div>
          {(
            <IonModal
              isOpen={showProductModal === i}
              className="modal--large news-gallery__modal"
              onDidDismiss={() => setProductModal(-1)}
            >
              <div data-testid="modal-content" className={`news-gallery__modal${obj.type === 'video' ? '-video' : '-image'}`}>
                {obj.type === 'video'
                  ? (
                  <iframe src={obj.url}/>
                    )
                  : (
                  <img src={obj.url} alt={obj.type} />
                    )}
              </div>
              {obj.type !== 'video' && (
                <div className="news-gallery__modal-button">
                  <a className="btn__primary" href={obj.url} hidden={obj.type === 'video'} download>
                    Download
                  </a>
                </div>
              )}
            </IonModal>
          )}
        </div>
      )
    })
  }

  return (
    <div className="news-gallery">
      <div className="news-gallery__grid">{renderGallery()}</div>
    </div>
  )
}
export default NewsMediaGallery
